let audio = null;

export const isGardenSoundOn = () => audio !== null;

export const startGardenSound = () => {
    if (audio) return;
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const master = ctx.createGain();
    master.gain.value = 0;
    master.connect(ctx.destination);
    master.gain.linearRampToValueAtTime(0.55, ctx.currentTime + 2.5);

    const len = ctx.sampleRate * 2;
    const buffer = ctx.createBuffer(1, len, ctx.sampleRate);
    const data = buffer.getChannelData(0);
    let last = 0;
    for (let i = 0; i < len; i++) {
        const white = Math.random() * 2 - 1;
        last = (last + 0.02 * white) / 1.02;
        data[i] = last * 3.5;
    }
    const src = ctx.createBufferSource();
    src.buffer = buffer;
    src.loop = true;
    const lp = ctx.createBiquadFilter();
    lp.type = "lowpass";
    lp.frequency.value = 420;
    const riverGain = ctx.createGain();
    riverGain.gain.value = 0.3;
    src.connect(lp);
    lp.connect(riverGain);
    riverGain.connect(master);
    src.start();

    const lfo = ctx.createOscillator();
    lfo.frequency.value = 0.13;
    const lfoGain = ctx.createGain();
    lfoGain.gain.value = 0.09;
    lfo.connect(lfoGain);
    lfoGain.connect(riverGain.gain);
    lfo.start();

    let birdTimer;
    const chirp = () => {
        const t0 = ctx.currentTime;
        const osc = ctx.createOscillator();
        const g = ctx.createGain();
        const f = 2200 + Math.random() * 1400;
        osc.frequency.setValueAtTime(f, t0);
        osc.frequency.exponentialRampToValueAtTime(f * 0.62, t0 + 0.13);
        g.gain.setValueAtTime(0, t0);
        g.gain.linearRampToValueAtTime(0.04, t0 + 0.02);
        g.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.18);
        osc.connect(g);
        g.connect(master);
        osc.start(t0);
        osc.stop(t0 + 0.22);
        birdTimer = setTimeout(chirp, 2500 + Math.random() * 7000);
    };
    birdTimer = setTimeout(chirp, 1200);

    audio = { ctx, stop: () => clearTimeout(birdTimer) };
    window.dispatchEvent(new Event("garden-sound-changed"));
};

export const stopGardenSound = async () => {
    if (!audio) return;
    audio.stop();
    try {
        await audio.ctx.close();
    } catch (e) {
        /* already closed */
    }
    audio = null;
    window.dispatchEvent(new Event("garden-sound-changed"));
};
